const state= {


};

const getters = {

};

const actions = {
    //Items
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/references`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/references`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/references/${params.id}`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/references`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async checkDeleteReference({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/references/check-delete-reference-type`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
